module.exports = __webpack_public_path__ + "img/back.84555e92.svg";